hrd.CssVariable = hrd.Class.extend({
	init: function(options){
		var defaults = {
			impl: 'hrd.CssVariable',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	get: function(name, element){
		name = this._normalize_(name);
		element = element || document.documentElement;
		return getComputedStyle(element).getPropertyValue(name);
	},
	set: function(name, value, element){
		name = this._normalize_(name);
		if(element == undefined){
			element = document.documentElement;
		} else {
			if (element instanceof jQuery){
			    element = element.get(0);
			} else {
				element = $(element).get(0);
			}
		}
		if(element && element.style){
			element.style.setProperty(name, value);
		}
	},
	_normalize_: function(name){
	    if(name.substr(0, 2) !== "--") {
	        name = "--" + name;
	    }
	    return name;
	}
});
const cssVar = new hrd.CssVariable();